// src/pages/common/UnauthorizedPage.tsx
import React from "react";
import { Link } from "react-router-dom";

const UnauthorizedPage: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center">
    <h1 className="text-4xl font-bold text-red-600 mb-4">Access Denied</h1>
    <p className="text-gray-600 mb-6">
      You don’t have permission to view this page.
    </p>
    <Link
      to="/app/dashboard"
      className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition"
    >
      Go Back to Dashboard
    </Link>
  </div>
);

export default UnauthorizedPage;
